import {
  cloneElement,
  forwardRef,
  useEffect,
  useRef,
  ReactElement,
} from 'react'

interface Props {
  in?: boolean
  children: ReactElement
  // Modal injects these to drive mount/unmount; fire them so it still works.
  onEnter?: () => void
  onEntered?: () => void
  onExit?: () => void
  onExited?: () => void
}

// Drop-in for MUI Drawer's TransitionComponent that renders the paper with no
// Slide/transform — the drawer just appears. Fires the lifecycle callbacks the
// Modal relies on to mount/unmount, and forwards the ref MUI's Modal/FocusTrap
// attach to the transition child.
const NoTransition = forwardRef<HTMLElement, Props>(
  ({ in: inProp, children, onEnter, onEntered, onExit, onExited }, ref) => {
    const wasIn = useRef<boolean | undefined>(undefined)

    useEffect(() => {
      if (wasIn.current === inProp) return
      wasIn.current = inProp
      if (inProp) {
        onEnter?.()
        onEntered?.()
      } else {
        onExit?.()
        onExited?.()
      }
    }, [inProp, onEnter, onEntered, onExit, onExited])

    return cloneElement(children, {
      ref,
      style: {
        ...(children.props.style || {}),
        ...(inProp ? {} : { display: 'none' }),
      },
    })
  },
)

export default NoTransition
